(function () {
  'use strict';

  var BSS_PORTAL_SELECTOR = '.bss-bcp, .bss-bcp-order, [class*="bss-b2b-customer-portal"]';

  function isInsideBssPortal(node) {
    if (!node || !node.closest) return false;
    return !!node.closest(BSS_PORTAL_SELECTOR);
  }

  function roundCents(cents) {
    var value = parseInt(cents, 10);
    if (isNaN(value)) return cents;
    var mod = value % 100;
    if (mod === 1) return value - 1;
    if (mod === 99) return value + 1;
    return value;
  }

  function roundTaxedCents(cents, taxRate) {
    var rate = taxRate || 1;
    return roundCents(Math.round(cents * rate));
  }

  window.feRoundCents = roundCents;
  window.feRoundTaxedCents = roundTaxedCents;

  function fixPriceString(text) {
    if (!text || typeof text !== 'string') return text;
    return text
      .replace(/(\d)([.,])01(?!\d)/g, '$1$200')
      .replace(/(\d+)([.,])99(?!\d)/g, function (match, intPart, sep) {
        return String(parseInt(intPart, 10) + 1) + sep + '00';
      });
  }

  function patchFormatMoney(target, key) {
    if (!target || typeof target[key] !== 'function' || target[key].__feRounded) return;

    var original = target[key];
    var patched = function (cents, format) {
      return original(roundCents(cents), format);
    };
    patched.__feRounded = true;
    target[key] = patched;
  }

  function patchAllFormatters() {
    if (window.Shopify) patchFormatMoney(window.Shopify, 'formatMoney');
    if (window.slate && window.slate.Currency) {
      patchFormatMoney(window.slate.Currency, 'formatMoney');
    }
  }

  var PRICE_SELECTORS = [
    '[data-product-price]',
    '[data-compare-price]',
    '[bss-b2b-product-price]',
    '[bss-b2b-variant-price]',
    '[bss-b2b-item-original-price]',
    '.product-item__price',
    '.cart__price',
    '.cart__total__price',
    '.item__price',
    '.new-price',
    '.old-price',
    '.product-upsell__price',
    '.custom-product__price',
    '.product__price--strike',
    '.product__price-info',
    '[data-price-round]'
  ].join(',');

  function fixPriceNode(el) {
    if (!el || isInsideBssPortal(el)) return;

    Array.prototype.forEach.call(el.childNodes, function (node) {
      if (node.nodeType !== 3) return;
      var fixed = fixPriceString(node.textContent);
      if (fixed !== node.textContent) node.textContent = fixed;
    });

    if (!el.children.length) {
      var fixedText = fixPriceString(el.textContent);
      if (fixedText !== el.textContent) el.textContent = fixedText;
    }
  }

  function fixPriceNodes(root) {
    var scope = root || document;
    scope.querySelectorAll(PRICE_SELECTORS).forEach(fixPriceNode);
  }

  function init() {
    patchAllFormatters();
    fixPriceNodes(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    patchAllFormatters();
    fixPriceNodes(document);
  });

  document.addEventListener('theme:variant:change', function () {
    window.setTimeout(function () {
      patchAllFormatters();
      fixPriceNodes(document);
    }, 50);
    window.setTimeout(function () {
      fixPriceNodes(document);
    }, 400);
  });

  if (typeof MutationObserver !== 'undefined' && document.body) {
    var timer;
    var observer = new MutationObserver(function (mutations) {
      var shouldUpdate = mutations.some(function (mutation) {
        var target = mutation.target;
        if (isInsideBssPortal(target)) return false;
        if (mutation.type === 'characterData' && isInsideBssPortal(mutation.target.parentElement)) {
          return false;
        }
        return true;
      });

      if (!shouldUpdate) return;

      clearTimeout(timer);
      timer = window.setTimeout(function () {
        patchAllFormatters();
        fixPriceNodes(document);
      }, 200);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
})();
